import React from 'react';

export const OpenCloseIndicator = ({isOpen, onClick}) => {
    
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
    }

    return (
        <div className={`open-close-indicator`} onClick={handleClick}>
            <span className="indicator-separator"></span>
            <div className={`indicator-image ${isOpen ? "open" : ""}`}  aria-hidden="true">
            </div>
        </div>
    )
}

export default OpenCloseIndicator;
